import { IonCheckbox } from "@ionic/react";

import {
  CONSENT_REQUIRED_MESSAGE,
  LEGAL_SLUG_BY_DOCUMENT,
  TERMS_PRIVACY_SEGMENTS,
  consentPlainText,
} from "../../constants/purchaseConsents";
import "./PurchaseTermsConsent.css";

/**
 * "Ho letto e accetto i Termini e Condizioni e dichiaro di aver preso visione
 * dell'Informativa Privacy." — unticked until the member ticks it, right above
 * the button that opens the Apple / Google sheet (client, 02/10/2026).
 */
const PurchaseTermsConsent = ({ checked, onChange, showError, onOpenDocument }) => {
  const inError = showError && !checked;

  return (
    // Lives inside a selectable plan card: a tap or key press here must not
    // reach the card and close it.
    <div
      className="purchase-terms-consent-wrap"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <div
        className={`purchase-terms-consent${inError ? " purchase-terms-consent--error" : ""}`}
      >
        <IonCheckbox
          aria-label={consentPlainText(TERMS_PRIVACY_SEGMENTS)}
          checked={checked}
          onIonChange={(event) => onChange(event.detail.checked)}
        />
        <span className="purchase-terms-consent__text">
          {TERMS_PRIVACY_SEGMENTS.map((segment, index) =>
            segment.type === "link" ? (
              <button
                key={index}
                type="button"
                className="purchase-terms-consent__link"
                onClick={() => onOpenDocument(LEGAL_SLUG_BY_DOCUMENT[segment.document])}
              >
                {segment.label}
              </button>
            ) : (
              <span key={index}>{segment.value}</span>
            ),
          )}
        </span>
      </div>
      {inError ? (
        <p className="purchase-terms-consent__error" role="alert">
          {CONSENT_REQUIRED_MESSAGE}
        </p>
      ) : null}
    </div>
  );
};

export default PurchaseTermsConsent;
